export enum ListSourceType {
  LIST_SPOTLIGHT = 'list-spotlight',
  LIST_EMAIL = 'list-email',
  LIST_LOCAL = 'list-local',
  LIST_DASHBOARD = 'list-dashboard',
  LIST_MODAL = 'list-modal',
  LIST_STORY_NAVIGATION = 'list-story-navigation',
  LIST_STORY_PAGE = 'list-story-page',
  LIST_SECONDARY_NAVIGATION = 'list-secondary-navigation',
  LIST_LANDING_PAGE = 'list-landing-page',
  LIST_LANDING_PAGE_NEWS_FEED = 'list-landing-page-news-feed',
  LIST_LANDING_PAGE_PROMOTION = 'list-landing-page-promotion',
}

export enum BasketItemSource {
  EMPTY = '',
  SEARCH = 'search',
  SEARCH_SUGGEST_PRODUCT = 'search-suggest-product',
  SEARCH_SUGGEST_FILTER = 'search-suggest-filter',
  SEARCH_SUGGEST_AUTOCOMPLETE = 'search-suggest-autocomplete',

  // Landing page stories:
  SEARCH_STORY_NAVIGATION = 'search-story-navigation',
  LIST_STORY_NAVIGATION = ListSourceType.LIST_STORY_NAVIGATION,
  SEARCH_STORY_PAGE = 'search-story-page',
  LIST_STORY_PAGE = ListSourceType.LIST_STORY_PAGE,

  // when CS opens on basket page
  BASKET = 'basket',

  // Landing page classic:
  SEARCH_SECONDARY_NAVIGATION = 'search-secondary-navigation',
  LIST_SECONDARY_NAVIGATION = ListSourceType.LIST_SECONDARY_NAVIGATION,
  SEARCH_LANDING_PAGE = 'search-landing-page',
  LIST_LANDING_PAGE = ListSourceType.LIST_LANDING_PAGE,
  LIST_LANDING_PAGE_NEWS_FEED = ListSourceType.LIST_LANDING_PAGE_NEWS_FEED,
  LIST_LANDING_PAGE_PROMOTION = ListSourceType.LIST_LANDING_PAGE_PROMOTION,

  RECOMMENDATION_PANEL = 'recommendation-panel',

  // List sources
  LIST_SPOTLIGHT = ListSourceType.LIST_SPOTLIGHT,
  LIST_EMAIL = ListSourceType.LIST_EMAIL,
  LIST_LOCAL = ListSourceType.LIST_LOCAL,
  LIST_DASHBOARD = ListSourceType.LIST_DASHBOARD,
  LIST_MODAL = ListSourceType.LIST_MODAL,
}
